import {useSelector} from 'react-redux';

import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, ...props }) => {
    const auth = useSelector(state => state.auth.auth);

    if ( auth === undefined ) {
        return <label></label>;
    }

    return (
        <Route {...props} render={ props => 
            !auth ? 
                <Redirect to="/"/> 
            : 
            <Component {...props} />
        } exact={props.exact === false ? undefined : true}/>
    )
}

export const Authform = ({component: Component, ...props}) =>{
    const auth = useSelector(state => state.auth.auth)
    
    if ( auth === undefined ) {
        return <label></label>;
    }

    return (
        <Route {...props} render={ props => auth ? <Redirect to="/projects"/> 
            : <Component {...props} />
        } exact/>
    )
}